<template>
    <v-card class="card-container">
        <v-card-text>
            <v-container fluid class="h-100">
                <v-data-table
                        :loading="loading"
                        no-data-text="Нет элементов"
                        no-results-text="Не найдено элементов"
                        loading-text="Загрузка данных"
                        calculate-widths
                        :items-per-page="stockItems.length"
                        :items="stockItems"
                        :headers="fields"
                        height="100%"
                        hide-default-footer
                        class="elevation-1 h-100"
                        @click:row="showDetailModal"
                >
                    <template v-slot:item.stockSize="{item}">
                        <div> {{ sizesStock.find(x=>x.value==item.stockSize).text }}</div>
                    </template>
                    <template v-slot:item.organization="{item}">
                        <div>{{item.organization.orgName}}</div>
                    </template>
                    <template v-slot:item.publishDate="{item}">
                        <div>{{formatDate(item.publishDate)}}</div>
                    </template>
                    <template v-slot:item.stockDescription="{item}">
                        <span style="color:var(--color-2)">{{ item.stockDescription.length>150?item.stockDescription.substr(0,150)+'...':item.stockDescription }}</span>
                    </template>

                </v-data-table>
            </v-container>
        </v-card-text>
        <detailsModal :show="showDetails" :item="selected" @close="closeDetailsModal"></detailsModal>
    </v-card>
</template>

<script>
    import detailsModal from '../Stocks/DetailsStockModal.vue'
    export default {
        name: "PartnerInfoStocks",
        components:{detailsModal},
        props:{
            item:Object
        },
        data(){
            return {
                showDetails:false,
                loading:false,
                selected:null,
                fields:[
                    {text: 'Название', value: 'stockTitle',width: "250px"},
                    {text: 'Размер плитки', value: 'stockSize',width: "150px"},
                    {text: 'Дата публикации', value: 'publishDate',width: "150px"},
                    {text: 'Текст акции', value: 'stockDescription'}
                ]
            }
        },
        mounted(){
            //получить список акций
            this.$store.dispatch("Partners/getStocks", this.item.id).catch(err=>{
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки списка акций!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })

        },
        computed:{
            sizesStock(){
                return this.$store.state.Stocks.sizesStock;
            },

            stockItems(){
                return this.$store.state.Partners.partnerStocks
            }
        },
        methods:{
            showDetailModal(e){
                this.selected=e
                this.showDetails=true

            },
            closeDetailsModal(isSave){
                this.selected=null
                this.showDetails=false
            }
        }
    }
</script>

<style scoped>

</style>